import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { log } from '../../services/utils';

import { getDocs } from '../../api/nora/assistant';

import { Provider as AdminProvider } from '../../contexts/AdminContext';
import { Provider as AgenciesProvider } from '../../contexts/AgenciesContext';
import { Provider as SubmissionsProvider } from '../../contexts/SubmissionsContext';
import { useUIAction } from '../../contexts/UIContext';

import AgencyRouter from './AgencyRouter';

const AgencyPortal = () => {
	const { setDocs } = useUIAction();

	useEffect( () => {
		( async () => {
			try {
				const docs = await getDocs();

				setDocs( docs );
			} catch ( error ) {
				// handle
			}
		} )();
	}, [ setDocs ] );

	return (
		<>
			{ log( 'agencyPortal' ) }
			<AgenciesProvider>
				<AdminProvider>
					<SubmissionsProvider>
						<BrowserRouter>
							<AgencyRouter />
						</BrowserRouter >
					</SubmissionsProvider>
				</AdminProvider>
			</AgenciesProvider>
		</>
	);
};

export default AgencyPortal;
